import OutlineFive from '@assets/icons/outline-five.svg'
import { Icon } from './Icon'

export const OutlineFiveIcon = Icon(OutlineFive)
